<div
  class="position-relative d-none d-md-block animate__animated animate__slideInLeft animate__faster bg-info ziro-left-nav mt-0 ms-detail-card-container"
>
  <div class="sidebar">
    <!-- Contact Card -->
    @if (microsoft360View?.microsoft365UserLicenses) {
      <div class="contact-card position-relative border-rad-all-2" [ngClass]="{ 'mt-5 pt-4': userPhoto }">
        @if (isResourceAccount) {
          <span
            class="custom-icon d-inline-flex justify-content-center align-items-center bg-white rounded-circle"
            [ngbTooltip]="'tkey;microsoft_360.view.contact.card.user.resource.account.icon' | translate"
            [tooltipClass]="'tooltip--white'"
            [placement]="'top'"
          >
            <a
              [href]="
                '/app2/#/helpdesk/tenants/' +
                tenantId +
                '/360-view/' +
                microsoft360View?.microsoft365UserLicenses.userPrincipalName
              "
              class="text-black d-inline-block mt-2 custom-icon__link"
              data-automation="microsoft-detail-card-phone-list"
            >
              <i [class]="ziroIcons.PHONE_LIST" class="fa-2x"></i>
            </a>
          </span>
        }
        @if (!userPhoto && !isResourceAccount) {
          <a
            [href]="
              '/app2/#/helpdesk/tenants/' +
              tenantId +
              '/360-view/' +
              microsoft360View?.microsoft365UserLicenses.userPrincipalName
            "
            class="text-white"
            data-automation="microsoft-detail-card-user-icon"
          >
            <i [class]="ziroIcons.CIRCLE_USER" class="fa-3x"></i>
          </a>
        }
        @if (userPhoto && !isResourceAccount) {
          <a
            [href]="
              '/app2/#/helpdesk/tenants/' +
              tenantId +
              '/360-view/' +
              microsoft360View?.microsoft365UserLicenses.userPrincipalName
            "
            data-automation="microsoft-detail-card-user-photo"
            class="avatar-pic-wrapper"
          >
            <img
              class="avatar-pic"
              [src]="userPhoto"
              [ngbTooltip]="'tkey;microsoft_360.view.contact.card.user.photo.tooltip' | translate"
              [tooltipClass]="'tooltip--white'"
              [placement]="'top'"
            />
          </a>
        }
        <br />
        <h5
          data-automation="microsoft-detail-card-name"
          class="no-margin"
          [ngbTooltip]="'tkey;microsoft_360.view.contact.card.user.display.name.tooltip' | translate"
          [tooltipClass]="'tooltip--white'"
          [placement]="'top'"
        >
          <span class="font-light">{{ microsoft360View?.microsoft365UserLicenses.displayName }}</span>
        </h5>
        <!--BADGES-->
        <div class="mt-2" data-automation="user-detail-card-account-status">
          <span data-automation="account-badge" [hidden]="!badge?.badgeText" [class]="badge?.outerSpanClass">
            @if (badge?.iconClass) {
              <i [class]="badge?.iconClass"></i>
            }
            <span
              [class]="badge?.innerSpanClass"
              [ngbTooltip]="badge?.tooltip | translate"
              [tooltipClass]="badge?.tooltipClass"
              [placement]="badge?.tooltipPlacement"
            >
              {{ badge?.badgeText | translate }}
            </span>
          </span>
        </div>
        @if (isResourceAccount) {
          <div class="mt-2" data-automation="user-detail-card-resource-account-type">
            <span
              data-automation="resource-account-type-badge"
              [hidden]="!resourceAccountBadge?.badgeText"
              [class]="resourceAccountBadge?.outerSpanClass"
            >
              @if (resourceAccountBadge?.iconClass) {
                <i [class]="resourceAccountBadge?.iconClass"></i>
              }
              <span
                [class]="resourceAccountBadge?.innerSpanClass"
                [ngbTooltip]="resourceAccountBadge?.tooltip | translate"
                [tooltipClass]="resourceAccountBadge?.tooltipClass"
                [placement]="resourceAccountBadge?.tooltipPlacement"
              >
                {{ resourceAccountBadge?.badgeText | translate }}
              </span>
            </span>
          </div>
        }
        <hr />
        <div
          [ngbTooltip]="'tkey;microsoft_360.view.contact.card.user.principal.name.tooltip' | translate"
          [tooltipClass]="'tooltip--white'"
          [placement]="'top'"
        >
          <a
            [href]="'mailto:' + microsoft360View?.microsoft365UserLicenses.userPrincipalName"
            data-automation="microsoft-detail-card-upn"
          >
            {{ microsoft360View?.microsoft365UserLicenses.userPrincipalName }}
          </a>
        </div>
        <div
          data-automation="microsoft-detail-card-usage-location"
          [ngbTooltip]="'tkey;microsoft_360.view.contact.card.usage.location.tooltip' | translate"
          [tooltipClass]="'tooltip--white'"
          [placement]="'top'"
          [ngClass]="isPendingUsageLocation ? ziroIcons.SAVING + ' text-warning' : ziroIcons.LOCATION"
          class="me-1 ms-detail-card-usage-location"
        >
          {{
            isPendingUsageLocation ? usageLocationPendingMsg : microsoft360View?.microsoft365UserLicenses?.usageLocation
          }}
        </div>
        <div data-automation="microsoft-detail-extension-info">
          @if (microsoft360View?.teamsPhoneNumberAssignment?.lineUri) {
            <a
              [href]="'tel://' + microsoft360View?.teamsPhoneNumberAssignment?.lineUri"
              data-automation="microsoft-detail-card-e164"
              [ngbTooltip]="'tkey;microsoft_360.view.contact.card.number.tooltip' | translate"
              [tooltipClass]="'tooltip--white'"
              [placement]="'top'"
              class="number-padding"
            >
              {{ microsoft360View?.teamsPhoneNumberAssignment?.lineUri | telephoneNumberFilter }}
            </a>
          }
          @if (
            microsoft360View?.teamsPhoneNumberAssignment?.lineUriExtension &&
            microsoft360View?.teamsPhoneNumberAssignment?.lineUri
          ) {
            <span>ext.</span>
          }
          @if (microsoft360View?.teamsPhoneNumberAssignment?.lineUriExtension) {
            <a
              [href]="'tel://' + microsoft360View?.teamsPhoneNumberAssignment?.lineUriExtension"
              data-automation="microsoft-detail-card-extension"
              [ngbTooltip]="'tkey;microsoft_360.view.contact.card.extension.tooltip' | translate"
              [tooltipClass]="'tooltip--white'"
              [placement]="'top'"
              class="extension-padding"
            >
              {{ microsoft360View?.teamsPhoneNumberAssignment?.lineUriExtension }}
            </a>
          }
          <!-- Only show shared calling number if no assigned number exists -->
          @if (
            microsoft360View?.teamsVoicePolicies?.sharedCallRoutingPolicy?.resourceAccountLineUri &&
            !microsoft360View?.teamsPhoneNumberAssignment?.lineUri
          ) {
            <a
              [href]="'tel://' + microsoft360View?.teamsVoicePolicies?.sharedCallRoutingPolicy?.resourceAccountLineUri"
              data-automation="microsoft-detail-card-e164"
              [ngbTooltip]="'tkey;microsoft_360.view.contact.card.number.shared_calling.tooltip' | translate"
              [tooltipClass]="'tooltip--white'"
              [placement]="'top'"
              class="number-padding"
            >
              {{
                microsoft360View.teamsVoicePolicies.sharedCallRoutingPolicy.resourceAccountLineUri
                  | telephoneNumberFilter
              }}
            </a>
          }
        </div>
      </div>
    }
  </div>
</div>
